export default __webpack_public_path__ + "static/media/images.b67bb7b3.jpg";